/* eslint-disable
    consistent-return
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';

import formatters from 'notebook/mediocre/formatted-text/formatters';
import FormattersConstants from 'notebook/mediocre/formatted-text/FormattersConstants';
import {hasAnyNavigationHash} from 'ui-library/hooks/useHashNavigation';

const {CHIP_WIDTH} = FormattersConstants;

// Returns first range of window selection - returns null if range is invalid.
// Range is invalid if there's no ranges or if range's startContainer is an anonymous div (Firefox).
function getRange() {
  if (!window.getSelection) {
    return null;
  }
  const selection = window.getSelection();
  if (selection == null) {
    return null;
  }
  if (selection.rangeCount === 0) {
    return null;
  }
  const range = selection.getRangeAt(0);
  // range.startContainer could be an anonymous div in Firefox, e.g. if you click the up/down buttons
  // on an <input type="number">. Anonymous div's properties cannot be accessed and will throw a
  // "Permission denied to access property 'nodeType'" error. Therefore, we must wrap in a try/catch.
  // Related + informative: https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    // oxlint-disable-next-line no-unused-expressions
    range.startContainer.nodeType;
    // oxlint-disable-next-line no-unused-expressions
    range.endContainer.nodeType;
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch {
    return null;
  }
  return range;
}

function nodeLength(node, ignorePoint) {
  if ($(node).is('[contentEditable=false]')) {
    if (ignorePoint) {
      return 0;
    } else {
      return CHIP_WIDTH;
    }
  }
  if (node.nodeType === 3) {
    return node.length;
  } else {
    let sum = 0;
    for (node of Array.from(node.childNodes)) {
      sum += nodeLength(node);
    }
    return sum;
  }
}

function selectionIsAtEnd(e) {
  return selectionEndsAtEnd(e, true);
}

function selectionEndsAtEnd(e, collapsed) {
  if (collapsed == null) {
    collapsed = false;
  }
  const range = getRange();
  if (range == null) {
    return false;
  }

  // TODO, can we create a range by using range.setEndAfter (last node), and then compare endcontainer/offsets?
  function lastChildNode(node) {
    const {length} = node.childNodes;
    if (length) {
      return lastChildNode(node.childNodes[length - 1]);
    } else {
      return node;
    }
  }

  // If this is an empty line (element node with no children), we're always at the end, and there won't be a
  // text node to use later.
  if (e.target.nodeType !== Node.TEXT_NODE && e.target.childNodes.length === 0) {
    return true;
  }

  const lastNode = lastChildNode(e.target);
  let {length} = lastNode;
  // If the textContent of a node ends with a newline, the browser seems
  // to ignore it when rendering, so we must account for it to
  // properly detect if we are at the end of a selection. We check >= length,
  // since the cursor could be before or after the new line.
  if (lastNode.textContent[lastNode.textContent.length - 1] === '\n') {
    length--;
  }
  const collapseCase = !collapsed || range.collapsed;
  return collapseCase && range.endContainer === lastNode && range.endOffset >= length;
}

function closest(container, selector) {
  // Get range
  const selection = window.getSelection();
  if (!selection.rangeCount) {
    return;
  }
  const range = selection.getRangeAt(0);
  // Ensure the range is inside container
  const {startContainer, endContainer} = range;
  if ($(startContainer).closest(container).length !== $(endContainer).closest(selector).length) {
    return;
  }
  const result = $(startContainer).closest(selector)[0];
  if (result !== $(endContainer).closest(selector)[0]) {
    return;
  }
  return result;
}

function selectionBeginsAtBeginning(e, collapsed) {
  let selectionStartsAtZero;
  if (collapsed == null) {
    collapsed = false;
  }
  const {target} = e;

  const range = getRange();
  if (range == null) {
    return false;
  }

  // Sometimes the browser renders the cursor before or after the inserted newline. We always treat
  // this is empty text, so the selection is at the beginning of the text.
  if (e.target.textContent === '\n') {
    selectionStartsAtZero = true;
  } else {
    const selectionIndices = getSelectionIndices();
    selectionStartsAtZero = selectionIndices != null && selectionIndices.start === 0;
  }

  return (
    selectionStartsAtZero &&
    (!collapsed || range.collapsed) &&
    $(range.startContainer).closest(target).length > 0
  );
}

function selectionIsAtBeginning(e) {
  return selectionBeginsAtBeginning(e, true);
}

function _childOffset(node, ignorePoint) {
  let sum = 0;
  while (node.previousSibling) {
    sum += nodeLength(node.previousSibling, ignorePoint);
    node = node.previousSibling;
  }
  return sum;
}

function _liOffset(node, parent, ignorePoint) {
  let offset = 0;
  while (node) {
    if (node === parent) {
      return offset;
    }
    offset += _childOffset(node, ignorePoint);
    node = node.parentNode;
  }
  return -1;
}

function rangeOffset(container, offset, parent, ignorePoint) {
  // If no parent exists, this will walk all the way up the tree to the root node, so bail out.
  if (!parent) {
    return -1;
  }
  if (container.nodeType === 3) {
    return _liOffset(container, parent, ignorePoint) + offset;
  }

  if (offset === container.childNodes.length) {
    // sumOffset is the offset upto the container
    //   and the whole container itself
    // note, node nesting are taken care of by the respective functions
    return _liOffset(container, parent, ignorePoint) + nodeLength(container, ignorePoint);
  }
  return _liOffset(container.childNodes[offset], parent, ignorePoint);
}

function getEditable(range) {
  return $(range.startContainer).closest('.editable')[0];
}

function getSelectionIndices() {
  const range = getRange();
  if (range == null) {
    return null;
  }
  const $div = $(getEditable(range));
  // If there is no editable container, then there is no selection.
  if (!$div[0]) {
    return null;
  }
  const start = rangeOffset(range.startContainer, range.startOffset, $div[0], false);
  const end = rangeOffset(range.endContainer, range.endOffset, $div[0], false);

  const sel = {cid: $div.attr('data-cid'), start, end};
  return sel;
}

function restoreSelection(containerEl, {start, end}) {
  if ($(containerEl).is('input, textarea')) {
    if (document.activeElement !== containerEl) {
      $(containerEl).focus();
    }

    containerEl.selectionStart = start;
    containerEl.selectionEnd = end;
    return;
  }

  let charIndex = 0;
  const range = document.createRange();
  range.setStart(containerEl, 0);
  range.collapse(true);

  const nodeStack = [containerEl];
  let foundStart = false;
  let stop = false;

  // If the first child is a point format element the focus must be given to
  // the container editable rather than the first text element. This results in
  // the cursor being correctly placed at the beginning of the line.
  const isPrecedingPointElement =
    start === 0 && containerEl.firstChild != null && $(containerEl.firstChild).is('[contentEditable=false]');

  if (!isPrecedingPointElement) {
    let next;
    // oxlint-disable-next-line no-cond-assign
    while (!stop && (next = nodeStack.pop())) {
      // oxlint-disable-next-line no-var, vars-on-top
      var nextCharIndex;
      const node = next;
      if ($(node).is('[contentEditable=false]')) {
        charIndex += CHIP_WIDTH;
        nextCharIndex = charIndex;
      } else if (node.nodeType === 3) {
        nextCharIndex = charIndex + node.length;
        if (!foundStart && charIndex <= start && start <= nextCharIndex) {
          range.setStart(node, start - charIndex);
          foundStart = true;
        }
        if (foundStart && charIndex <= end && end <= nextCharIndex) {
          range.setEnd(node, end - charIndex);
          stop = true;
        }
        charIndex = nextCharIndex;
      } else {
        let i = node.childNodes.length;
        while (i--) {
          nodeStack.push(node.childNodes[i]);
        }
      }
    }

    // The caret only displays correctly if a chip is surrounded by non-empty text nodes.
    // When the chip is at the end of the line, generate a blank text node, place it after,
    // and set the selection to beginning of text node.
    if (!foundStart && charIndex) {
      const t = document.createTextNode(' ');
      containerEl.appendChild(t);
      range.setStart(t, 0);
    }
  }

  if (start === end) {
    range.collapse(true);
  }

  if (document.activeElement !== containerEl) {
    // Check if we're in a hash navigation scenario and preserve scroll position
    let savedScrollTop = null;
    let scrollContainer = null;

    if (hasAnyNavigationHash()) {
      // Find the scroll container (.noteEditor-scrollContainer)
      scrollContainer = $(containerEl).closest('.noteEditor-scrollContainer')[0];
      if (scrollContainer) {
        savedScrollTop = scrollContainer.scrollTop;
      }
    }

    $(containerEl).focus();

    // Restore scroll position if it was disrupted by focus
    if (hasAnyNavigationHash() && scrollContainer && savedScrollTop != null) {
      // Use requestAnimationFrame to ensure the focus scroll happens first
      requestAnimationFrame(() => {
        if (scrollContainer.scrollTop !== savedScrollTop) {
          scrollContainer.scrollTop = savedScrollTop;
        }
      });
    }
  }

  // We skip setting the range if the existing range matches the desired range, as removeAllRanges can
  // cause reflows.
  const sel = window.getSelection();
  const oldRange = sel.rangeCount ? sel.getRangeAt(0) : undefined;
  if (
    oldRange != null &&
    ['startContainer', 'endContainer', 'startOffset', 'endOffset'].every((p) => oldRange[p] === range[p])
  ) {
    return;
  }
  sel.removeAllRanges();
  sel.addRange(range);
}

function beforeRange(e, range) {
  const before = document.createRange();
  before.setStart(e.target, 0);
  before.setEnd(range.startContainer, range.startOffset);
  const beforeFrag = before.cloneContents();
  return formatters.getFormattedTextFromRenderedElement(beforeFrag);
}

function afterRange(e, range) {
  const after = document.createRange();
  after.setStart(range.endContainer, range.endOffset);
  if (e.target.childNodes.length) {
    after.setEndAfter(e.target.childNodes[e.target.childNodes.length - 1]);
  } else {
    after.setEnd(e.target, 0);
  }
  const afterFrag = after.cloneContents();
  return formatters.getFormattedTextFromRenderedElement(afterFrag);
}

/**
 * @param  {object} e An object containing the `target` of the click
 * @return {object}   Text `before` and `after` the selection and the `selected` text.
 */
function partitionSelection(e) {
  let startContainerParent;
  const range = getRange();
  if (range == null) {
    return null;
  }

  // Ensure the range is contained within the target.
  const {startContainer, endContainer} = range;
  if (!($(startContainer).closest(e.target).length && $(endContainer).closest(e.target).length)) {
    return null;
  }

  const {text: beforeText, formats: beforeFormats} = beforeRange(e, range);
  const afterFormattedText = afterRange(e, range);
  const {text: selectedText, formats: selectedFormats} = formatters.getFormattedTextFromRenderedElement(
    range.cloneContents()
  );

  // Check whether the selection is immediately before or after a point element:
  // Because a point element exists at a point without consuming characters
  // it is ambiguous whether a selection precedes or follows a point element.
  function parentBelowEditable(el) {
    if (Array.from(el.parentNode.classList).includes('editable')) {
      return el;
    } else {
      return $(el).parentsUntil('.editable').get(-1);
    }
  }

  if (range.startContainer) {
    startContainerParent = parentBelowEditable(range.startContainer);
  }
  const afterPoint =
    startContainerParent &&
    range.startOffset === 0 &&
    $(startContainerParent.previousSibling).is('[contentEditable=false]');

  // EditableComponent adds an extra newline to the end to get around `whitespace: pre-wrap` ignoring a
  // trailing new line. Here we strip a trailing new line if it exists to make sure that what we add in render
  // does not modify our model.
  const allowMultiline = $(e.target).is('[data-allow-multiline]');
  if (allowMultiline && afterFormattedText.text.slice(-1) === '\n') {
    afterFormattedText.text = afterFormattedText.text.slice(0, -1);
  }

  return {
    before: beforeText,
    after: afterFormattedText.text,
    beforeFormats,
    afterFormats: afterFormattedText.formats,
    afterPoint,
    selected: selectedText,
    selectedFormats,
  };
}

function selectAll(node) {
  const selection = window.getSelection();
  const range = document.createRange();
  range.selectNodeContents(node);
  selection.removeAllRanges();
  selection.addRange(range);
}

export {
  getEditable,
  getRange,
  nodeLength,
  selectionEndsAtEnd,
  selectionBeginsAtBeginning,
  selectionIsAtEnd,
  selectionIsAtBeginning,
  selectAll,
  getSelectionIndices,
  restoreSelection,
  beforeRange,
  afterRange,
  partitionSelection,
  closest,
  rangeOffset,
};
